"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getQueryString = getQueryString;
const qs_1 = require("qs");
function getQueryString(parameters) {
    if (!parameters) {
        return '';
    }
    const filteredParams = {};
    for (const [key, value] of Object.entries(parameters)) {
        if (value === undefined || value === null || value === '') {
            continue;
        }
        filteredParams[key] = value;
    }
    return (0, qs_1.stringify)(filteredParams, { indices: false });
}
//# sourceMappingURL=queryString.js.map